define("ember-svg-jar/inlined/audience-insights", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.929 1.171a.571.571 0 011.142 0v.595a6.859 6.859 0 016.263 6.262h.595a.571.571 0 010 1.143h-.595a6.859 6.859 0 01-6.263 6.262v.595a.571.571 0 01-1.142 0v-.595a6.859 6.859 0 01-6.263-6.262h-.595a.571.571 0 010-1.143h.595A6.859 6.859 0 017.93 1.766V1.17zm6.257 6.857h-.543a.571.571 0 100 1.143h.543a5.709 5.709 0 01-2.293 4.027l-.33-1.149A3.187 3.187 0 008.5 9.742a2.286 2.286 0 100-4.57 2.286 2.286 0 000 4.57c-1.421 0-2.67.941-3.063 2.307l-.33 1.149A5.709 5.709 0 012.814 9.17h.543a.571.571 0 000-1.143h-.543a5.716 5.716 0 015.115-5.114v.543a.571.571 0 001.142 0v-.543a5.716 5.716 0 015.115 5.114z\"/>",
    "attrs": {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 17 17",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});